export default __webpack_public_path__ + "static/automator-walkthrough-399dd903c32723985cf9de4211b75c57.png";